/* jshint ignore:start */

var CoursesManager = (function($) {

    var instance;

    function init() {

        var _$showBtn,
            _$coursesFilter;

        var _cookieName = 'calendarView';


        function initCalendarControl()
        {
            // Fullcalendar calendar plugin. DOCS:
            // https://fullcalendar.io/docs

            // TODO: @Jorge hay un montón de formas de alimentar los eventos (JSON, google calendar...):
            // https://fullcalendar.io/docs/events-array

            if(typeof(CUSTOM_DATA) !='undefined' && CUSTOM_DATA != null) { 
                $('#calendar').fullCalendar({
                    locale: 'es',
                    header: {
                        left: 'prev',
                        center: 'title',
                        right: 'next'
                    },
                    events: CUSTOM_DATA.coursesData,
                    eventClick: function (event) {
                        if (event.url) {
                            window.open(event.url);
                            return false;
                        }
                    },
                    eventRender: function (event, element) {
                        element.qtip({
                            position: {
                                my: 'top left',
                                at: 'bottom left',
                            },
                            // show: 'click',
                            // hide: 'click',
                            show: {
                                solo: true
                            },
                            hide: {
                                fixed: true,
                                delay: 300
                            },
                            content: '<div class="course"><div class="course__inner"><div class="course__info"><h3 class="course__title"><a class="course__title-link" href="#">' + event.title + '</a></h3><address class="course__address"><p class="course__where">' + event.address + '</p><p class="course__where">' + event.cp + ' - <strong class="course__location">' + event.location + '</strong></p></address><div class="course__actions"><div class="course__action"><a class="course__action-link btn-link btn-link--gray btn-link--text-left btn-link--text-sm" href="' + event.addToCalendar + '" target="_blank"><span class="btn-link__text">Añadir a</span><svg class="btn-link__icon" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g class="btn-link__icon-fill" fill="#353535" fill-rule="evenodd"><path d="M5.656 8.812c0-.2-.163-.362-.363-.362H4.028c-.2 0-.362.162-.362.362v1.265c0 .2.162.362.362.362h1.265c.2 0 .363-.162.363-.362V8.812zM8.817 8.812c0-.2-.162-.362-.362-.362H7.19c-.2 0-.362.162-.362.362v1.265c0 .2.162.362.362.362h1.265c.2 0 .362-.162.362-.362V8.812zM11.98 8.812c0-.2-.163-.362-.363-.362h-1.265c-.2 0-.363.162-.363.362v1.265c0 .2.163.362.363.362h1.265c.2 0 .362-.162.362-.362V8.812zM5.656 11.974c0-.2-.163-.363-.363-.363H4.028c-.2 0-.362.162-.362.363v1.265c0 .2.162.362.362.362h1.265c.2 0 .363-.162.363-.362v-1.265zM8.817 11.974c0-.2-.162-.363-.362-.363H7.19c-.2 0-.362.162-.362.363v1.265c0 .2.162.362.362.362h1.265c.2 0 .362-.162.362-.362v-1.265zM11.98 11.974c0-.2-.163-.363-.363-.363h-1.265c-.2 0-.363.162-.363.363v1.265c0 .2.163.362.363.362h1.265c.2 0 .362-.162.362-.362v-1.265z"></path><path d="M14.241 1.778v1.933c0 .873-.708 1.577-1.581 1.577h-.998a1.586 1.586 0 0 1-1.591-1.577V1.77H5.574v1.94c0 .873-.718 1.577-1.59 1.577h-.999A1.578 1.578 0 0 1 1.404 3.71V1.778A1.438 1.438 0 0 0 .014 3.21v11.323c0 .79.64 1.44 1.431 1.44H14.2c.79 0 1.432-.65 1.432-1.44V3.21c0-.776-.627-1.408-1.39-1.43zm-.463 12.049a.619.619 0 0 1-.619.619H2.46a.619.619 0 0 1-.62-.619V7.978c0-.342.278-.619.62-.619h10.7c.342 0 .619.277.619.62v5.848z" fill-rule="nonzero"></path><path d="M2.982 4.252h.987c.3 0 .542-.243.542-.542V.542c0-.3-.243-.542-.542-.542h-.987c-.3 0-.543.243-.543.542V3.71c0 .3.243.542.543.542zM11.65 4.252h.986c.3 0 .543-.243.543-.542V.542c0-.3-.243-.542-.543-.542h-.987c-.3 0-.542.243-.542.542V3.71c0 .3.243.542.542.542z"></path></g></svg></a></div></div></div></div></div>'
                        });
                    }
                    // https://fullcalendar.io/docs/eventRender
                    // eventRender: function(eventObj, $el) {
                    //     $el.popover({
                    //         title: eventObj.title,
                    //         content: eventObj.description,
                    //         trigger: 'hover',
                    //         placement: 'top',
                    //         container: 'body'
                    //     });
                    // },
                })
            }
        }

        function initDatePicker() {
            // TODO: @jorge @new revisar la programación/configuración. Éste ejemplo lo he cogido del proyecto de abaco.

            // Rome datepicker plugin:
            // https://github.com/bevacqua/rome

            // Configuration examples:
            // https://bevacqua.github.io/rome/

            // Lista de días de vacaciones
            var HOLIDAY_LIST = [
                // '25/12/2018',
                // '01/01/2019',
                // '07/01/2019',
                // '25/03/2019',
                // '18/04/2019',
                // '19/04/2019',
                // '01/05/2019',
                // '03/06/2019',
                // '24/06/2019',
                // '01/07/2019',
                // '20/07/2019',
                // '07/08/2019',
                // '19/08/2019',
                // '14/10/2019',
                // '04/11/2019',
                // '11/11/2019',
                // '08/12/2019',
                // '25/12/2019'
            ];

            var dateTimeSelector = document.querySelector('.js-datetime-rome');
            var cal;
            var tomorrow;

            if (dateTimeSelector) {
                rome.moment.locale('es-ES');
                tomorrow = moment().startOf('day').add(1, 'days');


                cal = rome(scheduletime, {
                    inputFormat: 'DD/MM/YYYY',

                    time: false,

                    dateValidator: function (d) {
                        var selectedDate = moment(d).format('DD/MM/YYYY');
                        var isHoliday = HOLIDAY_LIST.indexOf(selectedDate)>=0;

                        // Excluímos las vacaciones y los domingos
                        return (!isHoliday && moment(d).day() !== 0);
                    }
                });

                cal.setValue(tomorrow.add(8));
            }
        }

        function initFilterCourses()
        {
            var $coursesFilterBtn = $('.js-filter-courses-btn');
            $coursesFilterBtn.on('click', function(e) {
                e.preventDefault();

                _$coursesFilter.submit();

            });

        }

        function setCookie(c_name, value, exdays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
            var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
            document.cookie = c_name + "=" + c_value;
        }

        function getCookie(c_name) {
            var i, x, y, ARRcookies = document.cookie.split(";");
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
                x = x.replace(/^\s+|\s+$/g, "");
                if (x == c_name) {
                    return unescape(y);
                }
            }
        }



        return {

            initCommon: function() {
                var courseSelector = '.course',
                    courseShowMod = 'course--show-description',
                    $courses = $(courseSelector),
                    courseViewActionSelector = '.courses-view__action',
                    courseViewActionMod = 'courses-view__action--selected',
                    $courseViewCalendar = $('.js-courses-view-calendar'),
                    $courseViewList = $('.js-courses-view-list'),
                    $courseViewCalendarBtn = $('.js-courses-view-calendar-btn'),
                    $courseViewListBtn = $('.js-courses-view-list-btn');

                $(document).on('click', function (e) {
                    $courses.removeClass(courseShowMod);
                });

                _$showBtn.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    $(this).closest(courseSelector).toggleClass(courseShowMod);
                });

                $courseViewCalendarBtn.on('click', function (e) {
                    e.preventDefault();

                    $(courseViewActionSelector).removeClass(courseViewActionMod);
                    $(this).closest(courseViewActionSelector).addClass(courseViewActionMod);
                    $courseViewList.hide();
                    $courseViewCalendar.show();
                    $('#calendar').fullCalendar('render');
                    setCookie(_cookieName, "calendar", 20);

                });

                $courseViewListBtn.on('click', function (e) {
                    e.preventDefault();

                    $(courseViewActionSelector).removeClass(courseViewActionMod);
                    $(this).closest(courseViewActionSelector).addClass(courseViewActionMod);
                    $courseViewCalendar.hide();
                    $courseViewList.show();
                    setCookie(_cookieName, "list", 20);
                });
            },

            initViewMode: function()
            {
                var courseViewActionSelector = '.courses-view__action',
                    courseViewActionMod = 'courses-view__action--selected',
                    $courseViewCalendar = $('.js-courses-view-calendar'),
                    $courseViewList = $('.js-courses-view-list'),
                    $courseViewCalendarBtn = $('.js-courses-view-calendar-btn'),
                    $courseViewListBtn = $('.js-courses-view-list-btn');


                var modeView = getCookie(_cookieName);

                switch (modeView) {
                    case 'list':
                        setCookie(_cookieName, "list", 20);
                        $courseViewCalendar.hide();
                        $courseViewList.show();

                        $courseViewListBtn.closest(courseViewActionSelector).addClass(courseViewActionMod);

                        break;

                    default:
                        setCookie(_cookieName, "calendar", 20);
                        $courseViewList.hide();
                        $courseViewCalendar.show();

                        $courseViewCalendarBtn.closest(courseViewActionSelector).addClass(courseViewActionMod);
                        break;
                }

            },



            init: function() {
                _$showBtn = $('.js-course-description-btn');
                _$coursesFilter = $('.js-form-filter-courses');

                if (_$coursesFilter.length) {
                    initDatePicker();
                    initCalendarControl();
                    initFilterCourses();
                }

                if (_$showBtn.length) {
                    this.initCommon();

                    this.initViewMode();
                }


            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

